<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="editedEntity">
          {{ editedEntity.data.datasource.name | translate }}/ {{ editedEntity.data.name | translate }}/ {{ editedEntity.name | translate }}

          " {{ $t("common.update") }}</span
        >
      </h2>

      <!--Auto Processing-->

      <h5 class="mb-1 mt-3">{{ $t("processing.auto-alt") }}</h5>

      <select v-if="form && form.feature" v-model="autoProcessing" class="form-control">
        <option :value="undefined">{{ $t("common.choose") }}</option>
        <option value="YES">{{ $t("common.yes") }}</option>
        <option value="NO">{{ $t("common.no") }}</option>
      </select>

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
const state = "datasubjectProcessingLegal";

export default {
  components: { SweetTextarea },
  data() {
    return {
      form: { process: undefined, datasource: undefined, datasubject: undefined },
    };
  },
  validations: {},
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v && Object.keys(v).length > 0) {
          this.form = { ...v };
        } else {
          this.form = {};
        }
      },
    },
  },
  computed: {
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
    autoProcessing: {
      get() {
        return this.form.feature.autoProcessing ? "YES" : "NO";
      },
      set(value) {
        this.form.feature.autoProcessing = value;
      },
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedDatasubject`];
    },
    isEditMode() {
      return this.editedEntity && this.$store.getters[`${state}/isEditMode`];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const initialCriteria = { ...this.criteria };
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = this.editedEntity;
        const { datasource } = data;
        const { process } = datasource;
        const { department } = process;

        this.$store.commit("inventoryFilter/department", department);
        this.$store.commit("inventoryFilter/process", process);
        this.$store.commit("inventoryFilter/datasource", datasource);
        this.$store.commit("inventoryFilter/data", data);
        this.$store.commit("inventoryFilter/datasubject", this.editedEntity);

        const form = {
          editOption: "OVERRIDE",
          payload: { autoProcessing: this.form.feature.autoProcessing },
          criteria: this.criteria,
        };
        await this.$store.dispatch("gdprInventoryBulkUpdate/update", form);

        this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-auto-processing");

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.$store.commit("inventoryFilter/department", initialCriteria.department);
        this.$store.commit("inventoryFilter/process", initialCriteria.process);
        this.$store.commit("inventoryFilter/datasource", initialCriteria.datasource);
        this.$store.commit("inventoryFilter/data", initialCriteria.data);
        this.$store.commit("inventoryFilter/datasubject", initialCriteria.datasubject);
      }
    },
  },
};
</script>
